<!--<ul class="navbar">

  <li class="nav-item" *ngIf="this.doituongSelect.Id!=null">
    <div class="btn-group mb-1 mr-1 paddingtop5" dropdown>
      <a class="nav-link" dropdownToggle>
        <i class="fa-2x mr-2 fas fa-print"></i>
        In
      </a>
      <div *dropdownMenu class="dropdown-menu" role="menu">
        <a class="dropdown-item" href="#" (click)="export('pdf',1)">In phiếu đề xuất</a>
        <a class="dropdown-item" href="#" (click)="export('xlsx',1)">Xuất phiếu đề xuất (excel)</a>
      </div>
    </div>
  </li>


  <li class="nav-item active" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)">
    <a class="nav-link" href="#" (click)="savectu(0)">
      <i class="fa-2x mr-2 fas fa-save"></i>
      Lưu lại
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="#" (click)="closeModal()">
      <i class="fa-2x mr-2 far fa-window-close">
      </i>
      Thoát
    </a>
  </li>
</ul>-->

<div class="control-section drag">
  <ejs-dialog #modalphoihop [buttons]='dlgButtons' [position]='position' [visible]='false' [header]='modalTitle' [animationSettings]='animationSettings'
              [resizeHandles]='resizeHandleDirection' [enableResize]='dialogResize' [allowDragging]='dialogdragging'
              [target]='target'
              [showCloseIcon]='false' [width]='width' (open)="dialogOpen()" (close)="dialogClose()">
    <app-tonghop-donvinoiboedit #ctdonviphoihopedit (savect)="savept($event)"></app-tonghop-donvinoiboedit>
    <ng-template #footerTemplate>
    </ng-template>
  </ejs-dialog> 
</div>

<div class="row">
  <!--thông tin công văn-->
  <div style="width:75%;float:left;margin-left:2px">

    <div class="row">
      <label class="control-label col-2">Sổ văn bản <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-4">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="6"
                   [openOnEnter]="false"
                   [items]="inputsocvs"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.so_cv"
                   (change)="onDoiTuongChange($event)">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2">Loại VB <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-4">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="6"
                   [openOnEnter]="false"
                   [items]="inputphanloais"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.phan_loai"
                   (change)="onLoaiVBChange($event)">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <!--<div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>-->
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row">
      <label class="control-label col-2">Số đi <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-2">
        <input type="text" tabindex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.SO_DEN">
      </div>
      <label class="control-label col-2">Ngày VB <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-2">
        <ejs-datepicker [format]="format" [enableMask]="enableMaskSupport" [(value)]='doituongSelect.ngay_cv'></ejs-datepicker>
      </div>
      <label class="control-label col-2">Ngày gửi <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-2">
        <ejs-datepicker [format]="format" [enableMask]="enableMaskSupport" [(value)]='doituongSelect.ngay_nhan'></ejs-datepicker>
        <!--<kendo-dateinput tabindex="2" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="ngayden"></kendo-dateinput>-->
      </div>
    </div>
    <div class="row">
      <label class="control-label col-2">Nơi soạn<span style="color:red">&nbsp;(*)</span></label>
      <div class="col-4">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="5"
                   [openOnEnter]="false"
                   [items]="inputnoiguis"
                   bindValue="ID"
                   bindLabel="ten"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.ID_NOIGUI"
                   (change)="onNoiSoanChange($event)">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <label class="control-label col-2">Người soạn</label>
      <div class="col-4">
        <ng-select #slNguoiSoan
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="5"
                   [openOnEnter]="false"
                   [items]="inputnguoisoans"
                   bindValue="ID"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.UserID_Soan">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>
    <div class="row">
      <label class="control-label col-2">Ký hiệu <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-4">
        <input type="text" autofocus tabindex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.so_ky_hieu">
      </div>

    </div>
    <div class="row">
      <label class="control-label col-2">Trích yếu <span style="color:red">&nbsp;(*)</span></label>
      <div class="col-10">
        <textarea type="text" tabindex="10" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.trich_yeu"></textarea>
      </div>
    </div>
    <div class="row">
      <!--<label class="control-label col-2">Chỉ đạo</label>
    <div class="col-4">
      <ng-select #slNoiGui
                 labelForId="99"
                 class="twcol"
                 [tabIndex]="7"
                 [openOnEnter]="false"
                 [items]="inputbophanchidaos"
                 bindValue="userid"
                 bindLabel="Ten"
                 notFoundText="Không có dữ liệu"
                 placeholder=""
                 [searchFn]="comboSearchFn_Ten"
                 [(ngModel)]="doituongSelect.bophan_chidao"
                 (change)="onDoiTuongChange($event)">
        <ng-template ng-option-tmp let-item="item">
          <div class="rTableRow">
            <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
          </div>

        </ng-template>
      </ng-select>
    </div>-->
      <label class="control-label col-2">Người ký</label>
      <div class="col-4">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="6"
                   [openOnEnter]="false"
                   [items]="inputnguoichidaos"
                   bindValue="userid"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.nguoi_chidao"
                   
                   >
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row">
      <label class="control-label col-2">Nơi nhận</label>
      <div class="col-10">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                    [multiple]="true"
                   [tabIndex]="5"
                   [openOnEnter]="false"
                   [items]="inputnoinhans"
                   bindValue="ID"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn_DV"
                   [(ngModel)]="doituongSelect.KIEU_NHAN2"
                   
                   >
          <ng-template ng-footer-tmp *ngIf="quyen_themdonvingoai===true">
            <a (click)="addDonVi()"><em class="mr-2 far fa-plus-square"></em>Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row">
      <label class="control-label col-2">Độ khẩn</label>
      <div class="col-4">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="7"
                   [openOnEnter]="false"
                   [items]="inputdokhans"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.do_khan"
                   >
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <!--<div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>-->
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2">Độ mật</label>
      <div class="col-4">
        <ng-select #slNoiGui
                   labelForId="99"
                   class="twcol"
                   [tabIndex]="6"
                   [openOnEnter]="false"
                   [items]="inputdomats"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.do_mat"
                   
                   >
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    
    <div class="row">
      <div class="col-2" style="vertical-align:middle;min-height:73px">Nội bộ</div>
      <div class="col-10">
        <a>
          <div class="row" (dblclick)="chondonvi('1')">
            <div class="col-12" *ngIf="doituongSelect.NN_NoiNhanHienThi!==null && doituongSelect.NN_NoiNhanHienThi!==''" style="overflow:auto;background-color:white">{{doituongSelect.NN_NoiNhanHienThi}}</div>
            <div class="col-12" *ngIf="doituongSelect.NN_NoiNhanHienThi==null || doituongSelect.NN_NoiNhanHienThi==''" style="overflow:auto;background-color:white">Chọn nơi nhận nội bộ</div>
          </div>
          
        </a>
      </div>
    </div>
    <div class="row">
      <label class="control-label col-2">Số bản</label>
      <div class="col-2">
        <input class="form-control"
               maxlength="20"
               currencyMask 
               [(ngModel)]="doituongSelect.so_ban"
               name="value"
               [placeholder]="'Số bản'"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
      <label class="control-label col-2">Hạn giải quyết</label>
      <div class="col-2">
        <ejs-datepicker [format]="format" [enableMask]="enableMaskSupport" [(value)]='doituongSelect.han_gq'></ejs-datepicker>
      </div>
      <div class="col-4">
        <div class="checkbox c-checkbox">
          <label style="vertical-align:middle">
            <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.yc_traloi" />
            <span class="fa fa-check"></span> Yêu cầu văn bản trả lời
          </label>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <div class="uploadtemplate">
          <div id='dropArea'>
            <span id='drop' class="droparea"> <a  id='browse'><u>Chọn file</u></a> </span>
            <ejs-uploader #defaultupload id='defaultfileupload' [asyncSettings]='path'
                          [dropArea]='dropElement' (removing)='onFileRemove($event)' [files]='preLoadFiles'
                         (uploading)="onFileUpload($event)"  title="Chọn file"
                          [allowedExtensions]='allowExtensions' (selected)='onSelected($event)'
                          (success)='onSuccess($event)'></ejs-uploader>
          </div>
        </div>
      </div>
      <!--<label class="control-label col-2">

      <ejs-uploader #defaultupload id='defaultfileupload' [asyncSettings]='path'
                    [dropArea]='dropElement' (removing)='onFileRemove($event)' [files]='preLoadFiles'
                    (uploading)="addHeaders($event)" title="Chọn file"
                    [allowedExtensions]='allowExtensions' (selected)='onSelected($event)'
                    (success)='onSuccess($event)'></ejs-uploader>
    </label>-->
      <div class="col-10">
        <div class="lbl" style=" float:left; width:84%; height:auto;border-style:none">
          <div id="lblFile">
            <div class="row" *ngFor="let u of doituongSelect.Files">
              <div class="col-11" style="float:left">
                <img src="{{u.icon}}" border="0" width="13" height="13"><a href="{{u.File_Path}}" return="" false="" tabindex="0" target="_blank">{{u.file_name}}</a>
              </div>
              <div class="col-1 css_btn_delete"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <label class="control-label col-2">Ghi chú</label>
      <div class="col-6">
        <input type="text" autofocus tabindex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ghi_chu">
      </div>
      <div class="col-4">
        <button class="mb-1 mr-1 btn btn-primary" href="#" (click)="savecvd(0)">
          <!--<i class="fa-2x mr-2 fas fa-save"></i>-->
          Lưu lại
        </button>
        <button class="mb-1 mr-1 btn btn-danger" href="#" (click)="closeModal()">
          <!--<i class="fa-2x mr-2 far fa-window-close"></i>-->
          Thoát
        </button>
      </div>
    </div>


    <!--<div class="row" style="color:black">
    <div class="col-6"></div>

  </div>-->

  </div>
  <!--danh sach công văn-->
  <div style="width:24%;float:left">
    <div>
      <div style="display: flex;justify-content: space-between;">
        <ul class="nav nav-tabs" ng-reflect-klass="nav" ng-reflect-ng-class="[object Object]" style="width:100%;">
          <li class="nav-item ng-star-inserted" [ngClass]="{'active': tabselected==1}"><a class="nav-link" [ngClass]="{'active': tabselected==1}" (click)="tabselected=1" href="javascript:void(0);" id=""><span></span>Đã phát hành</a></li>
          <li class="nav-item ng-star-inserted" [ngClass]="{'active': tabselected==2}"><a class="nav-link" [ngClass]="{'active': tabselected==2}" (click)="tabselected=2" href="javascript:void(0);" id=""><span></span>Chờ phát hành</a></li>
        </ul>
      </div>

      <div class="tab-content" style="padding: 1px 15px !important">
        <div class=" tab-pane" [ngClass]="{'active': tabselected==1}">
          <div class="row" style="overflow:auto;background:#fff">
            <div class="" style="min-height:400px;background:#fff;">
              1
            </div>
          </div>
        </div>
        <div class=" tab-pane" [ngClass]="{'active': tabselected==2}">
          <div class="row" style="overflow:auto;background:#fff">
            <div class="" style="min-height:400px;background:#fff;">
              2
            </div>
          </div>
        </div>


      </div>



    </div>
  </div>
</div>


<!--<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>

  </div>


</div>-->
<!--<modal #modaldonvi [cssClass]="'modal7'" [backdrop]="'static'">
  <modal-header [show-close]="true">
    <h4 class="modal-title">{{modalTitle}}</h4>
  </modal-header>
  <modal-body>
    <app-quantri-donviedit #dtedonvi (save)="saveDonVi($event)"></app-quantri-donviedit>
  </modal-body>
</modal>-->
<!--<modal #modaldonviphoihop [cssClass]="'modal600'" [backdrop]="'static'">
  <modal-header [show-close]="false">
    <h4 class="modal-title">Chọn</h4>
  </modal-header>
  <modal-body>
    <app-danhmuc-donviphoihopedit #dtdonviphoihop (save)="saveModalDV($event)"></app-danhmuc-donviphoihopedit>
  </modal-body>
</modal>-->
<!--<modal #modalphucdapcongvan [cssClass]="'modalsanpham800'" [backdrop]="'static'">
  <modal-header [show-close]="false">
    <h4 class="modal-title">Phúc đáp công văn</h4>
  </modal-header>
  <modal-body>
    <app-tuychon-phucdapcongvanedit #ctphucdapcongvanedit (savect)="saveBienPhapNV($event)"></app-tuychon-phucdapcongvanedit>
  </modal-body>
</modal>-->
<!--<modal #modalBZDinhKem [cssClass]="'modal800'" [backdrop]="'static'">
  <modal-header [show-close]="true">
    <h4 class="modal-title">Đính kèm</h4>
  </modal-header>
  <modal-body>
    <app-tonghop-dinhkemedit #dteBZDinhKem (savect)="savedk($event)"></app-tonghop-dinhkemedit>
  </modal-body>
</modal>-->
